class YandexMapLoader {
	load(afterLoad = null) {
		if (this.isLoaded()) {
			if (typeof afterLoad === 'function') {
				afterLoad();
			}

			return;
		}

		let script = this.getIncluded();
		if (!script) {
			script = document.createElement('script');

			script.setAttribute('src',`https://api-maps.yandex.ru/2.1/?apikey=${App.ymap.token}&suggest_apikey=${App.ymap.token_suggest}&lang=ru_RU`);
			script.setAttribute('id', 'ymap');

			document.head.appendChild(script);
		}

		script.addEventListener('load', () => {
			script.dataset.loaded = true;

			if (typeof afterLoad === 'function') {
				let counter = 100;
				let interval = setInterval(() => {
					if (typeof ymaps !== 'undefined' && typeof ymaps.Map !== 'function' && counter-- > 0) {
						return;
					}

					clearInterval(interval);

					if (typeof ymaps.Map !== 'undefined') {
						afterLoad();
					}
				}, 50);
			}
		});
	}

	getIncluded() {
		return document.querySelector('script#ymap');
	}

	isIncluded() {
		return Boolean(this.getIncluded());
	}

	isLoaded() {
		return this.getIncluded()?.dataset.loaded;
	}
}

export default YandexMapLoader;
